var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8TreasureMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "64px",
    height: "64px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#faefde",
    d: "M58.72,50.5l-16,6.22a2,2,0,0,1-1.47,0L22.68,49.27a2,2,0,0,0-1.38,0l-16,5.33A1,1,0,0,1,4,53.61V14.44a2,2,0,0,1,1.37-1.9L21.3,7.23a2,2,0,0,1,1.38,0l18.59,7.43a2,2,0,0,0,1.47,0l15.9-6.18A1,1,0,0,1,60,9.46V48.63A2,2,0,0,1,58.72,50.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#c5e4fa",
    d: "M56,16V45.87a1,1,0,0,1-.64.93L42,52.54,21,44.37l-.05,0L9.32,48.23a1,1,0,0,1-1.32-1V17.39a1,1,0,0,1,.68-1L21,12.34l.65-.22a1,1,0,0,1,.69,0l19.29,7.71a1,1,0,0,0,.37.08,1,1,0,0,0,.37-.07l12.27-4.77A1,1,0,0,1,56,16Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff7f0",
    d: "M42 57L21 49 21 7 42 15 42 57z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#e3f2ff",
    d: "M42,19.93V52.54L21,44.37v-32l.65-.22a1,1,0,0,1,.69,0l19.29,7.71A1,1,0,0,0,42,19.93Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M24 42.5a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2A1 1 0 0 0 24 42.5zM29 44.5a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2A1 1 0 0 0 29 44.5zM34 46.25a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2A1 1 0 0 0 34 46.25zM39 48a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0V49A1 1 0 0 0 39 48z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M60.13,7.81a2,2,0,0,0-1.85-.21l-15.9,6.18a1,1,0,0,1-.73,0L23.05,6.34A3,3,0,0,0,21,6.28L5.05,11.6A3,3,0,0,0,3,14.44V53.61a2,2,0,0,0,2.63,1.9l16-5.33a1,1,0,0,1,.69,0L40.9,57.64a3,3,0,0,0,2.2,0l16-6.22A3,3,0,0,0,61,48.63V9.46A2,2,0,0,0,60.13,7.81ZM59,48.63a1,1,0,0,1-.64.93l-16,6.22a1,1,0,0,1-.73,0L23.05,48.34A3,3,0,0,0,21,48.28L5,53.61V14.44a1,1,0,0,1,.68-.95L21.62,8.18a1,1,0,0,1,.69,0L40.9,15.64a3,3,0,0,0,2.2,0L59,9.46Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M22.71,11.21a2,2,0,0,0-1.37,0l-13,4.32A2,2,0,0,0,7,17.39V47.28a2,2,0,0,0,2.63,1.9l10.68-3.56a1,1,0,1,0-.63-1.9L9,47.28V17.39l13-4.32,19.29,7.72a2,2,0,0,0,1.47,0L55,16V45.87l-13.36,5.2A1,1,0,0,0,42,53a1,1,0,0,0,.36-.07l13.36-5.2A2,2,0,0,0,57,45.87V16a2,2,0,0,0-2.72-1.86L42,18.92Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ed7899",
    d: "M50.54,25.47a1,1,0,0,0-1.41,0L47,27.6l-2.12-2.12a1,1,0,0,0-1.41,1.41L45.59,29l-2.12,2.12a1,1,0,1,0,1.41,1.41L47,30.42l2.12,2.12a1,1,0,1,0,1.41-1.41L48.41,29l2.12-2.12A1,1,0,0,0,50.54,25.47Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M43.26,29.41a1,1,0,0,0-1.11-.88,6.83,6.83,0,0,0-5.94,5.53l-.47,2.83a3,3,0,0,1-4.17,2.25L28.95,38a4,4,0,0,1-2.28-2.76L23.79,22.75a4.59,4.59,0,0,0-9,.49L13,37.89a1,1,0,1,0,2,.24l1.75-14.65a2.59,2.59,0,0,1,5.1-.28l2.87,12.46a6,6,0,0,0,3.42,4.14L30.76,41a5,5,0,0,0,7-3.75l.47-2.81a4.83,4.83,0,0,1,4.2-3.9A1,1,0,0,0,43.26,29.41Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8TreasureMap);
export default __webpack_public_path__ + "static/media/icons8-treasure-map.f5b7108d5db1dc59783048f52eb45ea1.svg";
export { ForwardRef as ReactComponent };